'use client';
import { jsxs as f, jsx as s } from "react/jsx-runtime";
import { cn as u, formatNumberWithZeroPrefix as $ } from "@tameeni/shared-logic";
import q, { useCallback as z, useState as w, useEffect as R } from "react";
import { Skeleton as B } from "../skeleton/skeleton.js";
const G = {
  Comma: ",",
  Colon: ":"
}, H = ({
  expiresOn: o,
  deadline: c,
  title: h,
  onCountdownFinish: i,
  on5MinutesLeft: m,
  descriptionClassName: A,
  containerClassName: b,
  separator: C = "Colon",
  customSeparator: I,
  isTimeout: p,
  disableDay: S,
  disableHours: U = !1,
  isLoading: j,
  locale: d = "en",
  shouldLocalizeNumbers: v,
  hasLabels: k,
  customTimeLabels: r = {}
}) => {
  const D = (e) => {
    let t = 0;
    return e.days && (t += e.days * 24 * 60 * 60 * 1e3), e.hours && (t += e.hours * 60 * 60 * 1e3), e.minutes && (t += e.minutes * 60 * 1e3), e.seconds && (t += e.seconds * 1e3), t;
  }, x = z(() => {
    if (o) {
      const e = (/* @__PURE__ */ new Date()).getTime();
      return new Date(o).getTime() - e;
    }
    return D(c || {});
  }, [o, c]), [g, y] = w(
    x()
  ), [N, T] = w(0), _ = (e) => {
    const t = Math.floor(e / 864e5), a = Math.floor(e / (1e3 * 60 * 60) % 24), n = Math.floor(e / 1e3 / 60 % 60), l = Math.floor(e / 1e3 % 60);
    return { days: t, hours: a, minutes: n, seconds: l };
  }, { days: E, hours: P, minutes: W, seconds: Z } = _(g), M = [
    ...S ? [] : [
      {
        value: E,
        label: r.day || "days",
        labelAr: r.day || "أيام"
      }
    ],
    ...U ? [] : [
      {
        value: P,
        label: r.hour || "hours",
        labelAr: r.hour || "ساعات"
      }
    ],
    {
      value: W,
      label: r.minute || "mins",
      labelAr: r.minute || "دقائق"
    },
    {
      value: Z,
      label: r.second || "sec",
      labelAr: r.second || "ثواني"
    }
  ];
  return R(() => {
    const e = setInterval(() => {
      y((t) => {
        const a = t - 1e3;
        return a <= 1e3 ? (clearInterval(e), i && i(), 0) : (a <= 3e5 && m && N === 0 && (m(), T(1)), a);
      });
    }, 1e3);
    return () => clearInterval(e);
  }, [
    N,
    m,
    i,
    x,
    c
  ]), R(() => {
    p && y(0);
  }, [p]), /* @__PURE__ */ f(
    "div",
    {
      "data-testid": "timeout-container",
      role: "timer",
      className: u("flex items-center gap-0.5", b),
      children: [
        h && /* @__PURE__ */ s("div", { className: "md:text-sm", children: h }),
        j ? /* @__PURE__ */ s(B, { className: "h-4 w-10" }) : g > 0 && /* @__PURE__ */ s(
          "div",
          {
            dir: "ltr",
            className: u("flex min-w-14", A),
            "data-testid": "timeout",
            children: M.map(({ value: e, label: t, labelAr: a }, n) => {
              const l = d === "ar" ? a : t;
              return /* @__PURE__ */ f("div", { className: "flex center", children: [
                /* @__PURE__ */ f(
                  "span",
                  {
                    className: u(
                      "flex center gap-0.5",
                      !v && d === "ar" ? "flex-row-reverse" : "flex-row"
                    ),
                    "data-testid": `timeout-${l}`,
                    children: [
                      $(
                        e,
                        v ? d : "en"
                      ),
                      k && /* @__PURE__ */ s("span", { className: "text-xs", children: l })
                    ]
                  },
                  n
                ),
                /* @__PURE__ */ s("span", { className: "mx-0.5", children: n < M.length - 1 && (I || G[C]) })
              ] }, n);
            })
          }
        )
      ]
    }
  );
}, X = q.memo(H);
export {
  X as Timer
};
